import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    heading: "1. Agreement",
    paragraphs: [
      'These Terms of Service ("Terms") govern your use of Rooted, operated by BeyondBible. By creating an account or using Rooted, you agree to these Terms and our Privacy Policy.',
      "If you do not agree, do not use the App. Contact: downloadrooted@gmail.com.",
    ],
  },
  {
    heading: "2. Eligibility",
    paragraphs: [
      "You must be at least 13 years old to use Rooted. By using the App, you represent that you meet this requirement.",
    ],
  },
  {
    heading: "3. Account",
    paragraphs: [
      "You are responsible for your account credentials and for activity under your account. Provide accurate information, keep your password confidential, and notify us promptly of unauthorised use.",
      "You may optionally connect a phone-derived hash for contact-based friend finding. You confirm that any number you enter is yours to use. Rooted does not currently independently verify ownership by SMS. We may suspend or terminate accounts that violate these Terms or that create risk for other users or for BeyondBible.",
    ],
  },
  {
    heading: "4. The service",
    paragraphs: [
      "Rooted provides faith-oriented daily scripture, challenges, personal reflection tools, friends features, and optional private Bible Pods and membership features. Features may change over time.",
      "Spiritual content in Rooted is for personal encouragement and study. It is not professional counselling, medical, legal, or pastoral advice for crisis situations. If you are in crisis, seek appropriate local help.",
      "Some study, translation, retrieval, or explanatory content may be AI-assisted. AI output can be incomplete or incorrect and should be checked against the cited scripture and trusted human guidance. Do not rely on it for high-impact decisions.",
    ],
  },
  {
    heading: "5. Friends-only challenge feed",
    paragraphs: [
      "Challenge responses and related community posts in Rooted are intended to be shared with your accepted friends, not published as open public content on the internet. You are responsible for who you add as friends and what you share with them.",
    ],
  },
  {
    heading: "6. Contact-based friend finding",
    paragraphs: [
      "Contact friend-finding is optional. If you grant Contacts permission and (where required) connect a phone, Rooted may show which of your contacts are already on the App and let you send friend requests or invites.",
      "You must only share contacts you are allowed to share under applicable law and device settings. Do not use matching or invites to spam, harass, or scrape other users.",
      "Invites you send (for example via Messages) are your responsibility. Friend codes remain available as an alternative way to connect.",
    ],
  },
  {
    heading: "7. User content",
    paragraphs: [
      "You retain ownership of content you create (such as reflections, photos, captions, voice notes, and pod annotations).",
      "By submitting content to Rooted, you grant BeyondBible a worldwide, non-exclusive, royalty-free licence to host, store, reproduce, and display that content solely to operate and improve the App (including showing it to friends or pod members as intended by the feature).",
      "You represent that you have the rights to the content you upload and that it does not infringe others' rights.",
      "You authorise us to use automated tools and human review to detect abuse, investigate reports, and enforce these Terms. Automated tools can make mistakes; you may contact us to request review.",
    ],
  },
  {
    heading: "8. Community standards (acceptable use)",
    paragraphs: ["You agree not to post, share, or use Rooted to engage in content or behaviour that is:"],
    list: [
      "Illegal, threatening, harassing, hateful, or abusive.",
      "Sexually exploitative, pornographic, or involving minors in any harmful way.",
      "Spam, scams, malware, or attempts to disrupt the service.",
      "Impersonation, doxxing, or invasion of another person's privacy.",
      "Misuse of nudges, friend codes, contact matching, invites, or pods to harass or spam others.",
      "Content that infringes copyright, trade marks, privacy, publicity, or other rights.",
    ],
  },
  {
    heading: "9. Reporting and enforcement",
    paragraphs: [
      "Use the in-app Report and Block controls where available, or contact downloadrooted@gmail.com with the relevant user, content, reason, and supporting details. We may preserve evidence, remove or restrict content, warn users, suspend accounts, disable accounts, or refer serious matters to authorities where required.",
      "We prioritise credible reports involving child safety, threats, sexual exploitation, or immediate danger. Response timing depends on severity and available information; no particular outcome or response time is guaranteed.",
      "To ask us to review an enforcement decision, email downloadrooted@gmail.com with your account details and the decision you dispute.",
    ],
  },
  {
    heading: "10. Pods and membership",
    paragraphs: [
      "Bible Pods are private groups for invited or code-joining members. Respect pod rules and other members' contributions.",
      "Some features may require a paid Rooted membership. Purchases and renewals are handled by the Apple App Store or Google Play under their terms. Manage or cancel subscriptions in your store account settings.",
    ],
  },
  {
    heading: "11. Intellectual property",
    paragraphs: [
      "BeyondBible and its licensors own the App software, branding, and original materials we provide (excluding your user content and third-party scripture texts as attributed). You may not copy, reverse engineer, or misuse the App except as allowed by law.",
      "Copyright owners or authorised agents may send a notice to downloadrooted@gmail.com identifying the protected work, the allegedly infringing Rooted content and its location, their contact details, a good-faith statement, a statement of accuracy and authority, and a physical or electronic signature. We may request more information before acting.",
      "We may remove or disable allegedly infringing content and notify the affected user. Where legally available, the user may submit a counter-notice. We may terminate users who repeatedly infringe copyright in appropriate circumstances.",
    ],
  },
  {
    heading: "12. Disclaimers",
    paragraphs: [
      'Rooted is provided "as is" and "as available" to the fullest extent permitted by Australian law. We do not warrant uninterrupted or error-free service.',
      "Nothing in these Terms excludes rights you cannot waive under the Australian Consumer Law.",
    ],
  },
  {
    heading: "13. Limitation of liability",
    paragraphs: [
      "To the maximum extent permitted by law, BeyondBible is not liable for indirect, incidental, special, consequential, or punitive damages, or loss of data, profits, or goodwill, arising from your use of Rooted.",
      "Our aggregate liability for claims relating to the App is limited to the greater of (a) amounts you paid us for Rooted membership in the 12 months before the claim, or (b) AUD $50, except where liability cannot be limited by law.",
    ],
  },
  {
    heading: "14. Termination",
    paragraphs: [
      "You may stop using Rooted and delete your account at any time. We may suspend or end access if you breach these Terms or if we discontinue the service. Provisions that by nature should survive (including licences already granted for operating the service, disclaimers, and liability limits) will survive termination.",
    ],
  },
  {
    heading: "15. Governing law",
    paragraphs: [
      "These Terms are governed by the laws of Australia. Courts in Australia will have non-exclusive jurisdiction, without prejudice to mandatory consumer protections that apply where you live.",
    ],
  },
  {
    heading: "16. Changes",
    paragraphs: [
      'We may update these Terms from time to time. We will update the "Last updated" date. Continued use after changes constitutes acceptance where permitted by law. If a change is material, we may provide additional notice in the App where practical.',
    ],
  },
  {
    heading: "17. Contact",
    paragraphs: [
      "BeyondBible",
      "Email: downloadrooted@gmail.com",
      "Governing law: Australia",
      "This document is provided for transparency and store compliance. For formal legal advice, consult a qualified professional.",
    ],
  },
];

export default function TermsPage() {
  return (
    <LegalPage
      testId="page-terms"
      title="Terms of Service"
      updated="28 July 2026"
      contact="downloadrooted@gmail.com"
      sections={SECTIONS}
    />
  );
}
